 
// Force WhatsApp links to open in new tab
(function() {
  // console.log("custom whatsapp target_blank loaded")
  function setWhatsAppTarget() {
    const selectors = [
      '#HeaderMenu-discuter-sur-whatsapp',
      '#HeaderDrawer-discuter-sur-whatsapp',
      'a[href*="wa.me"]'
    ];
    
    selectors.forEach(function(selector) {
      const links = document.querySelectorAll(selector);
      links.forEach(function(link) {
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
      });
    });
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setWhatsAppTarget);
  } else {
    setWhatsAppTarget();
  }
  
  // Run when drawer opens (for mobile menu)
  document.addEventListener('click', function(e) {
    if (e.target.matches('[data-drawer-trigger]') || e.target.closest('[data-drawer-trigger]')) {
      setTimeout(setWhatsAppTarget, 100);
    }
  });
})();
 